export default __webpack_public_path__ + "static/media/time.baa1ffd7.svg";